import { useEffect } from "react";
import useGetUserInfo from "@/hooks/queries/useGetUserInfo";

export function useUserInfoPreload(token?: string, loginInProgress?: boolean) {
  const { refetchUserInfo, data: userInfo, isFetching } = useGetUserInfo();

  useEffect(() => {
    if (token && !loginInProgress && !userInfo) {
      refetchUserInfo();
    }
  }, [token, loginInProgress, userInfo, refetchUserInfo]);

  return {
    userInfo,
    userInfoLoading: isFetching,
  };
}
